import { Filters } from '@/core/collections/filters/filter.interface';
import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Customer } from '../customers/customer.interface';
import { Position } from '../positions/position.interface';
import { Candidate } from './../candidates/candidate.interface';

export interface MatchingState {
   overview?: ApiResource<Array<Customer | Position | Candidate>>;
   filters?: Filters;
   query?: LocationQuery;
   activeIndex: number;
}

const MatchingStore: Module<MatchingState, StoreState> = {
   namespaced: true,
   state: {
      filters: { quick_search: [], filter_elements: [] },
      activeIndex: 0,
   },
   getters: {
      overview: (state) => state.overview,
      filters: (state) => state.filters,
      query: (state) => state.query,
      activeIndex: (state) => state.activeIndex,
   },
   mutations: {
      SET_OVERVIEW(state, overview?: ApiResource<Array<Customer | Position | Candidate>>) {
         state.overview = overview;
      },
      SET_FILTERS(state, filters: Filters) {
         state.filters = filters;
      },
      SET_QUERY(state, query: LocationQuery) {
         state.query = query;
      },
      UPDATE_ACTIVE_ITEM(state, item: Candidate | Position | Customer) {
         if (state.overview) {
            const index = state.overview.data.findIndex((oi) => oi.id === item.id);
            if (state.overview.data[index]) {
               state.overview.data.splice(index, 1, item);
            }
         }
      },
      DELETE_ACTIVE_ITEM(state, item: Candidate | Position) {
         if (state.overview) {
            state.overview.data = state.overview.data.filter((oi) => oi.id !== item.id);
         }
      },
   },
   actions: {},
};

export default MatchingStore;
